import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogoaertigacabbooking() {



const cardData =
{
  keyword: 'Pune to Goa Ertiga Cab Booking',

  heading: 'Lotus Cab: Pune to Goa Ertiga Cab Booking ',

headingDescription:
  "Lotus Cabs provides comfortable and affordable Pune to Goa Ertiga Cab Booking services for families, small groups, corporate travelers, weekend getaways, holiday trips, and one-way or round-trip journeys. Our spacious Ertiga cabs offer a perfect combination of comfort, safety, and convenience with ample seating and luggage space for long-distance travel. Driven by professional and experienced chauffeurs, every journey is planned for a smooth and relaxing experience. With 24x7 booking support, transparent pricing, doorstep pickup from any location in Pune, well-maintained vehicles, and reliable highway travel, Lotus Cabs ensures a safe, comfortable, and hassle-free Ertiga cab journey from Pune to Goa.",



  top: 'Top Places to Visit in Goa before Traveling to Pune with Lotus Cab',

topPlaces: [

  
    {
        title: "Mollem National Park",
        description:
            "Mollem National Park is a biodiversity hotspot located in the Western Ghats, home to diverse wildlife, dense forests, waterfalls, and numerous trekking trails. Nature lovers visit the park to experience Goa's rich flora and fauna."
    },
      {
        title: "Church of Our Lady of the Immaculate Conception",
        description:
            "Located in Panaji, the Church of Our Lady of the Immaculate Conception is famous for its iconic white façade, elegant stairways, and centuries-old history. It is one of Goa's most photographed landmarks and offers beautiful views of the city."
    },
  
      {
        title: "Vagator Beach",
        description:
            "Vagator Beach is a scenic coastal destination known for its dramatic red cliffs, soft golden sand, and breathtaking sunsets over the Arabian Sea. The beach offers a peaceful atmosphere, trendy cafés, and stunning viewpoints, making it a favorite among photographers and couples."
    },
     {
        title: "Butterfly Beach",
        description:
            "Butterfly Beach is a secluded paradise surrounded by lush forests and crystal-clear waters. Accessible mainly by boat or trekking, the beach is ideal for travelers seeking tranquility, dolphin sightings, and breathtaking natural beauty."
    },
       {
        title: "Se Cathedral",
        description:
            "Se Cathedral is one of the largest churches in Asia and a remarkable example of Portuguese-Gothic architecture. Dedicated to Saint Catherine, the cathedral is admired for its grand interiors, historic significance, and the famous Golden Bell."
    },
    {
        title: "Colva Beach",
        description:
            "Colva Beach is one of South Goa's most beautiful beaches, stretching for several kilometers with soft white sand and swaying coconut palms. Visitors enjoy swimming, beach walks, water sports, seafood restaurants, and a relaxing coastal ambiance."
    },
    {
        title: "Arambol Beach",
        description:
            "Arambol Beach is popular for its bohemian vibe, live music, yoga retreats, and vibrant beachside cafés. The beach attracts backpackers and international travelers looking for a laid-back atmosphere and unforgettable sunset views."
    },
    {
        title: "Divar Island",
        description:
            "Divar Island is a peaceful river island that showcases Goa's traditional village life, Portuguese-era churches, scenic landscapes, and lush paddy fields. Visitors enjoy ferry rides, cycling, and exploring the island's rich cultural heritage."
    },
    {
        title: "Naval Aviation Museum",
        description:
            "The Naval Aviation Museum in Vasco da Gama displays vintage aircraft, helicopters, engines, and naval artifacts that highlight the history of the Indian Navy's aviation wing. It is an educational attraction for families and aviation enthusiasts."
    },
    {
        title: "Fontainhas",
        description:
            "Fontainhas is Goa's charming Latin Quarter, famous for its colorful Portuguese-style houses, narrow winding streets, art galleries, cafés, and vibrant cultural heritage. Walking through this picturesque neighborhood offers a glimpse into Goa's colonial past."
    }
],





"services": [
  {
    "name": "Pune to Goa Ertiga Cab Booking",
    "description": "Book Pune to Goa Ertiga cab booking service for comfortable and affordable long-distance travel. The spacious 6-seater Ertiga is ideal for family vacations, weekend trips, and group tours to Goa. Enjoy doorstep pickup, experienced drivers, and transparent pricing with flexible one-way and round-trip packages. Well-maintained AC vehicles ensure a smooth and relaxing journey across highways and ghat sections."
  },
  {
    "name": "Pune to Goa Ertiga Cab",
    "description": "Reliable Pune to Goa Ertiga cab service offering comfortable seating, ample luggage space, and economical fares for long-distance travel. Perfect for families and small groups looking for a spacious vehicle with modern amenities and professional chauffeurs. Available for one-way, round-trip, and customized travel itineraries."
  },
  {
    "name": "Pune to Goa Ertiga Taxi",
    "description": "Travel conveniently with Pune to Goa Ertiga taxi service designed for family holidays and leisure trips. The AC Ertiga provides comfortable seating for up to six passengers and extra luggage capacity, making it one of the most preferred options for Goa travel. Professional drivers ensure a safe and enjoyable journey."
  },
  {
    "name": "Pune to Goa Ertiga Rental",
    "description": "Book Pune to Goa Ertiga rental service for a hassle-free road trip with spacious seating and comfortable interiors. Suitable for tourists, family vacations, and weekend getaways, the service offers flexible travel schedules and transparent pricing. Enjoy a comfortable journey with experienced drivers and well-maintained vehicles."
  },
  {
    "name": "Pune to Goa Ertiga Hire",
    "description": "Affordable Pune to Goa Ertiga hire service for long-distance travel with comfortable seating and professional chauffeurs. Ideal for families and small groups seeking economical transportation without compromising on comfort and safety. Available for customized travel packages and holiday trips."
  },
  {
    "name": "Pune to Goa 6 Seater Cab",
    "description": "Pune to Goa 6 seater cab service is perfect for family vacations and group travel. Spacious seating, ample luggage space, and air-conditioned interiors make the journey comfortable and enjoyable. Flexible pickup timings and experienced drivers ensure a stress-free trip to Goa."
  },
  {
    "name": "Pune to Goa Family Ertiga",
    "description": "Pune to Goa family Ertiga service is specially designed for families seeking comfortable and affordable transportation. The vehicle provides generous seating and luggage space, making it ideal for beach vacations, holiday trips, and long-distance travel with children and senior citizens."
  },
  {
    "name": "Pune to Goa SUV Cab",
    "description": "Book a Pune to Goa SUV cab for spacious and premium travel with comfortable seating and additional luggage capacity. Ideal for group tours and family holidays, the service offers reliable transportation with professional drivers and flexible travel plans."
  },
  {
    "name": "Pune to Goa AC Ertiga",
    "description": "Travel comfortably with Pune to Goa AC Ertiga service featuring air-conditioned interiors and spacious seating arrangements. Suitable for long-distance travel, family vacations, and leisure trips, the vehicle ensures a smooth and pleasant journey to Goa."
  },
  {
    "name": "Pune to Goa Ertiga Fare",
    "description": "Get transparent Pune to Goa Ertiga fare details with clear pricing based on travel distance, toll charges, and driver allowance. Affordable fare plans make the Ertiga one of the best choices for family and group travel to Goa."
  },
  {
    "name": "Pune to Goa Ertiga Price",
    "description": "Check Pune to Goa Ertiga price options for one-way and round-trip travel packages. Competitive pricing, comfortable vehicles, and professional service make Ertiga an economical option for long-distance intercity travel."
  },
  {
    "name": "Pune to Goa Outstation Ertiga",
    "description": "Reliable Pune to Goa outstation Ertiga service offering comfortable and safe long-distance travel with experienced drivers. Ideal for family vacations, holiday tours, and business trips requiring spacious and affordable transportation."
  },
  {
    "name": "Pune to Goa One Way Ertiga",
    "description": "Affordable Pune to Goa one way Ertiga service allowing passengers to pay only for the single-side journey. Perfect for tourists and travelers planning an extended stay in Goa without the need for a return trip."
  },
  {
    "name": "Pune to Goa Round Trip Ertiga",
    "description": "Flexible Pune to Goa round trip Ertiga packages are available for weekend getaways, family vacations, and business travel. Enjoy customized return schedules, comfortable seating, and professional drivers for a stress-free travel experience."
  },
  {
    "name": "Best Pune to Goa Ertiga Cab",
    "description": "Best Pune to Goa Ertiga cab service offering clean vehicles, professional chauffeurs, and affordable pricing. The spacious Ertiga is perfect for families and small groups seeking comfortable and reliable transportation to Goa with excellent customer support and flexible travel options."
  }
],

"tableData": [
  ["Pune to Goa Ertiga Cab Booking", "Pune to Goa Ertiga Cab"],
  ["Pune to Goa Ertiga Taxi", "Pune to Goa Ertiga Rental"],
  ["Pune to Goa Ertiga Hire", "Pune to Goa 6 Seater Cab"],
  ["Pune to Goa Family Ertiga", "Pune to Goa SUV Cab"],
  ["Pune to Goa AC Ertiga", "Pune to Goa Ertiga Fare"],
  ["Pune to Goa Ertiga Price", "Pune to Goa Outstation Ertiga"],
  ["Pune to Goa One Way Ertiga", "Pune to Goa Round Trip Ertiga"],
  ["Best Pune to Goa Ertiga Cab", ""]
],






"whychoose": [
  {
    "WhyChooseheading": "Spacious Ertiga for Family Trips",
    "WhyChoosedescription": "The Maruti Ertiga offers comfortable seating and ample luggage space for Goa vacations."
  },
  {
    "WhyChooseheading": "Affordable Cab Booking",
    "WhyChoosedescription": "Enjoy budget-friendly Pune to Goa travel with transparent pricing and no hidden charges."
  },
  {
    "WhyChooseheading": "Ideal for Groups",
    "WhyChoosedescription": "Perfect vehicle choice for families and small groups traveling together to Goa."
  },
  {
    "WhyChooseheading": "One Way & Round Trip Options",
    "WhyChoosedescription": "Book an Ertiga cab for a one-way drop or a complete round-trip package."
  },
  {
    "WhyChooseheading": "Doorstep Pickup Service",
    "WhyChoosedescription": "Convenient pickup available from homes, hotels, offices, airports, and railway stations in Pune."
  },
  {
    "WhyChooseheading": "Clean and Air-Conditioned Vehicles",
    "WhyChoosedescription": "Travel in well-maintained AC Ertiga cabs for a comfortable long-distance journey."
  },
  {
    "WhyChooseheading": "Professional Drivers",
    "WhyChoosedescription": "Experienced chauffeurs ensure safe and smooth travel through highways and ghat roads."
  },
  {
    "WhyChooseheading": "Quick Booking Confirmation",
    "WhyChoosedescription": "Get instant assistance and confirmation for your Pune to Goa Ertiga cab booking."
  }
]
};

const faqData = [
  {
    question: 'Does Lotus Cab provide Pune to Goa Ertiga cab booking?',
    answer: 'Yes, Lotus Cab offers reliable Pune to Goa Ertiga cab booking services for one-way and round-trip travel.'
  },
  {
    question: 'Why should I choose an Ertiga for Pune to Goa travel?',
    answer: 'The Ertiga is an excellent choice for families and small groups because it offers comfortable seating and sufficient luggage space.'
  },
  {
    question: 'What is the distance between Pune and Goa by road?',
    answer: 'The distance from Pune to Goa is approximately 450 km, and the journey usually takes around 8 to 10 hours.'
  },
  {
    question: 'How much does a Pune to Goa Ertiga cab cost?',
    answer: 'The fare depends on the travel date, trip type, and pickup location. Lotus Cab provides competitive and transparent pricing.'
  },
  {
    question: 'Can I book a one-way Ertiga cab to Goa?',
    answer: 'Yes, we offer economical one-way Ertiga cab services from Pune to Goa.'
  },
  {
    question: 'Is pickup available from Pune Airport and railway station?',
    answer: 'Yes, Lotus Cab provides pickup services from Pune Airport, railway stations, hotels, and residential locations.'
  },
  {
    question: 'Are toll and state taxes included in the fare?',
    answer: 'Toll charges, parking fees, and state taxes are generally charged separately unless specifically included in the package.'
  },
  {
    question: 'Is night travel available for Pune to Goa Ertiga booking?',
    answer: 'Yes, our Ertiga cab services are available for both daytime and overnight departures.'
  },
  {
    question: 'Can I book an Ertiga for a round trip to Goa?',
    answer: 'Absolutely. We provide flexible round-trip packages for families, tourists, and business travelers.'
  },
  {
    question: 'How can I book Pune to Goa Ertiga Cab with Lotus Cab?',
    answer: 'Share your pickup location, travel date, passenger details, and booking requirements to receive an instant quotation and confirmation.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Pratik More',
    feedback: 'Since we were traveling with six family members, the Ertiga turned out to be the perfect choice. Everyone had enough space, and the ride to Goa was very comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Patil',
    feedback: 'I reserved an Ertiga for our friends trip to Goa, and the experience was wonderful. The vehicle was clean, the driver was polite, and we reached our destination without any hassle.',
    rating: 5,
  },
];








































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Goa Ertiga Cab Booking",
"image": "https://lotuscab.com/assets/images/pune-to-goa-ertiga-cab-booking.jpg",
"description": "Book Pune to Goa Ertiga Cab Booking with Lotus Cab for comfortable, spacious, and affordable outstation travel. Hire Ertiga cabs for family trips, one way journeys, round trips, and long distance travel with professional drivers and 24x7 taxi service.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7215"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹18/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/pune-to-goa-ertiga-cab-booking"
}
};





  return (
    <div>
      
<Helmet>
  <title>Pune to Goa Ertiga Cab Booking | Family SUV Taxi Service | +91 8767592195</title>

<meta
 name="description"
 content="Book Pune to Goa Ertiga Cab Booking with Lotus Cab for safe and comfortable travel. Get 6 seater Ertiga, family SUV, one way, round trip, and outstation cab services at affordable fares with professional drivers."
/>

<meta
 name="keywords"
 content="Pune to Goa Ertiga Cab Booking, Pune to Goa Ertiga Cab, Pune to Goa Ertiga Taxi, Pune to Goa Ertiga Rental, Pune to Goa Ertiga Hire, Pune to Goa 6 Seater Cab, Pune to Goa Family Ertiga, Pune to Goa SUV Cab, Pune to Goa AC Ertiga, Pune to Goa Ertiga Fare, Pune to Goa Ertiga Price, Pune to Goa Outstation Ertiga, Pune to Goa One Way Ertiga, Pune to Goa Round Trip Ertiga"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/102.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogoaertigacabbooking;